export default "__VITE_ASSET__Bg2EjhM6__"